import { LogoutRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/logout/$')({
  component: LogoutRoute,
});
